import axios from "axios";
import { api } from "../../../services/apiHelpers";

export const GET_REPORTING_CHART = "GET_REPORTING_CHART";
export const REPORTING_ACTION_ERROR = "REPORTING_ACTION_ERROR";
export const getReportingChart =
    (entity = "", year = null, isActive = null) =>
    dispatch => {

        return new Promise((resolve, reject) => {

            let url = `/reporting/chart/infos/${entity}`;

            const params = [];

            if (year !== null && year !== "all") {
                params.push(`year=${year}`);
            }

            if (isActive !== null) {
                params.push(`isActive=${isActive}`);
            }

            if (params.length > 0) {
                url += `?${params.join("&")}`;
            }

            axios.post(api + url)
                .then(res => {
                    if (res.data) {
                        dispatch({
                            type: GET_REPORTING_CHART,
                            data: res.data
                        });

                        resolve(res.data);
                    } else {
                        resolve([]);
                    }
                })
                .catch(error => {
                    dispatch({
                        type: REPORTING_ACTION_ERROR,
                        data: error
                    });

                    reject(error);
                });
        });
    };

export const exportReporting = (
    entity = "employers",
    year = null,
    isActive = null
) => {
    return async () => {
        try {

            const params = {};

            if (year !== null && year !== "all") {
                params.year = year;
            }

            if (isActive !== null) {
                params.isActive = isActive;
            }

            const response = await axios.get(
                `${api}/reporting/export/${entity}`,
                {
                    params,
                    responseType: "blob"
                }
            );

            const currentDate = new Date();

            const timeStamp =
                `${currentDate.getDate()}-` +
                `${currentDate.getMonth() + 1}-` +
                `${currentDate.getFullYear()}_` +
                `${currentDate.getHours()}h` +
                `${currentDate.getMinutes()}mn` +
                `${currentDate.getSeconds()}`;

            const fileName =
                `Malibaara_Reporting-${entity}-` +
                `${year ?? "all"}-` +
                `${isActive ?? "all"}_` +
                `${timeStamp}.xlsx`;

            const blob = new Blob([response.data]);

            const downloadUrl = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute("download", fileName);

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);

            return response;

        } catch (error) {
            console.error("Erreur export :", error);
            throw error;
        }
    };
};
